import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider as ReduxProvider } from "react-redux"

import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import store from "./redux/store"

// import i18n (needs to be bundled)
import './i18n'

import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';

Amplify.configure(awsExports);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

// @TODO dig a bit more on this later,
// replaced by "root.render(<App />)" to avoid calling events twice.
//root.render(
//  <React.StrictMode>
//    <App />
//  </React.StrictMode>
//)

root.render(
  //<React.StrictMode>
    <ReduxProvider store={store}>
      <App />
    </ReduxProvider>
  //</React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
